import { useEffect } from 'react';
import type { RefObject } from 'react';

// orbit의 useOutside (PageMemberPerms 내부)와 동등.
// 메뉴 외부 클릭 시 닫기.
export function useOutsideClick(
  ref: RefObject<HTMLElement>,
  open: boolean,
  onClose: () => void,
): void {
  useEffect(() => {
    if (!open) return;
    const handler = (event: MouseEvent) => {
      const el = ref.current;
      if (!el) {
        onClose();
        return;
      }
      if (!el.contains(event.target as Node)) onClose();
    };
    // 같은 tick의 트리거 클릭을 무시하기 위해 다음 tick에서 attach
    const id = window.setTimeout(() => {
      document.addEventListener('mousedown', handler);
    }, 0);
    return () => {
      window.clearTimeout(id);
      document.removeEventListener('mousedown', handler);
    };
  }, [ref, open, onClose]);
}
